export default __webpack_public_path__ + "static/media/da266c3a-a094-4adc-a81e-12f73609ba16.211d0e83.eot";